import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { ConfirmMessageService } from '@frontend/bingo/frontend-lib/core';
import { DeviceService } from '@frontend/vanilla/core';

import { SessionPackageService } from '../../../services/session-package.service';
import { TopandtailPopupComponent } from '../../tickets/pre-buy-grid/topandtail-popup/topandtail-popup.component';

@Component({
    selector: 'bg-fabgrab-room',
    templateUrl: './fabgrab-room.component.html',
    imports: [CommonModule, TopandtailPopupComponent],
})
export class FabGrabRoomComponent implements OnInit, OnDestroy {
    isFriendsRoom: boolean;
    selectTeamModal: boolean;
    content: any = [];
    packageDetails: any;
    globalClientConfig: any;
    @Input() SelectedRoomId: any;
    @Input() game: any;
    @Input() games: any;
    @Input() row_no: number;
    @Input() isSessionBingo: boolean;
    @Input() col_no: number;
    @Input() isPurchased: boolean;
    @Output() OnTeamModalOpen: EventEmitter<any> = new EventEmitter<any>();
    @Output() OnTotalTicketsSelected: EventEmitter<any> = new EventEmitter<any>();
    @Output() ticketsSelectedCount: EventEmitter<any> = new EventEmitter<any>();
    numbers: number[] = [];
    assignIoClass: boolean;
    clientConfig: any;
    public currentGame: any;
    private fabGrabRoomIds: number[];
    private isFabGrabRoom: boolean;
    private _totalPrice: number;

    constructor(
        private confirmMessageService: ConfirmMessageService,
        private sessionService: SessionPackageService,
        private deviceService: DeviceService,
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<TopandtailPopupComponent>,
    ) {}
    ngOnDestroy(): void {
        this.games = [];
    }
    ngOnInit(): void {
        this.packageDetails = this.games;
        // if(this.isSessionBingo)
        //   this.Games=this.Games[0].game_Info;
        // else
        this.games = this.games[this.row_no].game_Info;
        this.constructNumebrs();
        this.fabGrabRoomIds = [];
        if (localStorage.getItem('config')) {
            this.clientConfig = JSON.parse(localStorage.getItem('config')!);
            if (!this.globalClientConfig) this.globalClientConfig = this.clientConfig?.global;
        }
        this.content = this.clientConfig?.sessionGlobalMessages;
        if (this.globalClientConfig?.messages?.fabGrabRoomIds) {
            this.fabGrabRoomIds = this.globalClientConfig?.messages?.fabGrabRoomIds.split(',').map((item: any) => {
                return parseInt(item, 10);
            });
            if (this.fabGrabRoomIds.indexOf(this.SelectedRoomId) > -1) {
                this.isFabGrabRoom = true;
            }
        }
        //remove this line since added for testing
        this.selectNumbers(false);
    }
    constructNumebrs() {
        this.numbers = [];
        for (let i = 1; i <= this.content?.FabGrabBallCount; i++) {
            this.numbers.push(i);
        }
    }
    selectNumbers(isModal: boolean) {
        if (this.deviceService.isiOS && this.deviceService.isMobile) {
            this.sessionService.setClassStatusforIOS(true);
        }
        this.currentGame = this.games[this.col_no]; //[0].game_Info[index];
        if (this.currentGame != undefined) {
            if (
                this.currentGame.game_context.FomoBingo.fomo_numbers == null &&
                this.currentGame.game_context.FomoBingo.previous_fomo_numbers?.length > 0
            )
                this.currentGame.game_context.FomoBingo.fomo_numbers = this.currentGame.game_context.FomoBingo.previous_fomo_numbers.slice(
                    0,
                    this.currentGame.game_context.FomoBingo.maximum_numbers,
                );
            else if (this.currentGame.game_context.FomoBingo.fomo_numbers == null) this.currentGame.game_context.FomoBingo.fomo_numbers = [];
            if (isModal && !this.isPurchased) {
                //this.selectNumbersModal = true;
                const requiredModalData = {
                    currentGame: this.currentGame,
                    content: this.content,
                    luckyDipText: 'LUCKY DIP',
                    isFabGrabComponent: true,
                };
                this.dialogRef = this.dialog.open(TopandtailPopupComponent, {
                    data: requiredModalData,
                    panelClass: 'top-n-tail-popup',
                });
                this.dialogRef.componentInstance.onSelected.subscribe((response) => {
                    if (response) {
                        this.Selected({
                            id: +this.games.indexOf(response.currentGame),
                            selectedValue: +response.currentGame.current_purchased_count,
                        });
                    }
                });
                this.dialogRef.componentInstance.onNumbersClosed.subscribe((response) => {
                    if (response) {
                        this.onNumbersClose();
                    }
                });
                this.OnTeamModalOpen.emit(true);
            }
        }
    }

    showInfo(maxnumers: any) {
        const message = this.globalClientConfig.messages.fabGrabInfoMessage.replace('XX', maxnumers),
            header = this.globalClientConfig.messages.fabGrabInfoHeader,
            closeBtn = this.globalClientConfig.messages.confirmCloseButton;
        this.confirmMessageService.confirmThis(
            header,
            message,
            '',
            '',
            closeBtn,
            () => {},
            () => {},
        );
    }

    selectPattern() {
        this.currentGame.game_context.FomoBingo.fomo_numbers = [];
        // let pattern = JSON.parse(this.globalClientConfig.messages.fabGrabPatterns)[p];
        // if (!pattern) {
        const pattern = this.GetRandomPattern(1, 90, this.currentGame.game_context.FomoBingo.maximum_numbers, []);
        //}
        this.currentGame.game_context.FomoBingo.fomo_numbers = pattern;
        this.Selected({
            id: +this.games.indexOf(this.currentGame),
            //selectedValue: +this.currentGame.current_purchased_count
        });
    }
    Selected(obj: any) {
        this.currentGame = this.games[obj.id];
        const prevVal = this.currentGame.current_purchased_count === undefined ? 0 : this.currentGame.current_purchased_count;
        //this.currentGame.current_purchased_count = obj.selectedValue;
        if (this.isFabGrabRoom && this.currentGame.game_context.FomoBingo.fomo_numbers == null) {
            this.currentGame.game_context.FomoBingo.fomo_numbers = [];
        }
        if (this.isFriendsRoom && this.currentGame.game_context.TeamBingo.current_team == null) this.onRandomSelected();
        if (this.currentGame.isMultistake) {
            this._totalPrice = this._totalPrice - prevVal * this.currentGame.ticket_cost.Cash;
            this.currentGame.ticket_cost.Cash = parseFloat(
                this.currentGame.game_context.VariableCardStake.ticket_prices_player_currency[this.currentGame.selected_price],
            );
            this._totalPrice = this._totalPrice + this.currentGame.current_purchased_count * this.currentGame.ticket_cost.Cash;
        }
        // console.log(this._selectedTickets);
        // this.OnTotalTicketsSelected.emit({
        //   totalPurchasedTickets: this._totalPurchasedTickets,
        //   totalPrice: this._totalPrice,
        //   purchaseTickets: this._selectedTickets
        // });
    }

    onRandomSelected() {
        const RandomSelectIndex = Math.floor(Math.random() * this.currentGame.game_context.TeamBingo.teams.length);
        this.currentGame.game_context.TeamBingo.current_team = this.currentGame.game_context.TeamBingo.teams[RandomSelectIndex];
        this.selectTeamModal = false;
        this.OnTeamModalOpen.emit(false);
    }
    GetRandomPattern = (min: number, max: number, count: number, result: number[]): number[] => {
        const n = Math.floor(Math.random() * max) + min;
        if (result.indexOf(n) < 0) {
            count--;
            result.push(n);
        }
        if (count != 0) this.GetRandomPattern(min, max, count, result);
        return result;
    };
    onNumbersClose() {
        if (!this.currentGame.game_context.FomoBingo.previous_fomo_numbers && this.currentGame.game_context.FomoBingo.fomo_numbers.length == 0) {
            this.dialogRef.close();
            return;
        }
        if (this.currentGame.game_context.FomoBingo.fomo_numbers.length < this.currentGame.game_context.FomoBingo.minimum_numbers) {
            const message = this.globalClientConfig.messages.fabGrabMinSelectMessage,
                header = this.globalClientConfig.messages.fabGrabAlertHeader,
                closeBtn = this.globalClientConfig.messages.confirmCloseButton;
            this.confirmMessageService.confirmThis(
                header,
                message,
                '',
                '',
                closeBtn,
                () => {},
                () => {},
            );
            return;
        }
        this.dialogRef.close();
        // this.Game.game_context.FomoBingo.fomo_numbers=this.currentGame.game_context.FomoBingo.fomo_numbers;
        const selectedTickets =
            this.game?.game_context?.FomoBingo?.fomo_numbers == null ? 0 : this.currentGame?.game_context?.FomoBingo?.fomo_numbers.length;
        //let totalCount=this.numbers.length;
        const outCount = selectedTickets;
        this.sessionService.setClassStatusforIOS(false);
        if (this.isSessionBingo) {
            this.ticketsSelectedCount.emit({ val: outCount, key: this.col_no });
        }
        this.OnTeamModalOpen.emit(false);
        this.updateOnTicketsSelected();
    }
    onNumberSelect(n: number) {
        const index = this.currentGame.game_context.FomoBingo.fomo_numbers.indexOf(n);
        if (index !== -1) this.currentGame.game_context.FomoBingo.fomo_numbers.splice(index, 1);
        else {
            if (this.currentGame.game_context.FomoBingo.fomo_numbers.length == this.currentGame.game_context.FomoBingo.maximum_numbers) {
                const message = this.globalClientConfig.messages.fabGrabMaxSelectMessage,
                    header = this.globalClientConfig.messages.fabGrabAlertHeader,
                    closeBtn = this.globalClientConfig.messages.confirmCloseButton;
                this.confirmMessageService.confirmThis(
                    header,
                    message,
                    '',
                    '',
                    closeBtn,
                    () => {},
                    () => {},
                );
                return;
            } else this.currentGame.game_context.FomoBingo.fomo_numbers.push(n);
        }
        this.Selected({
            id: +this.games.indexOf(this.currentGame),
            selectedValue: +this.currentGame.current_purchased_count,
        });
    }
    updateOnTicketsSelected() {
        // if(this.isSessionBingo)
        //   this.packageDetails[0].game_Info=this.Games;
        // else
        this.packageDetails[this.row_no].game_Info = this.games;
        this.sessionService.updateTicketsSelectedDetails({
            gameDetails: this.packageDetails,
        });
    }
}
